import React, { useEffect, useState } from "react";
import api from "../services/api";

function Students({ setPage }) {

const [students, setStudents] = useState([]);
const [search, setSearch] = useState("");

const [currentPage,setCurrentPage] = useState(1);
const studentsPerPage = 15;

useEffect(() => {

expireAccess();
loadStudents();

}, []);

const expireAccess = async () => {

try {

await api.put("/students/access/expire/run");

} catch (err) {

console.log(err);

}

};

const loadStudents = async () => {

try {

const res = await api.get("/students");

setStudents(res.data.data || []);

} catch (err) {

console.log(err);

}

};

const deleteStudent = async (id) => {

const confirmDelete = window.confirm(
"Are you sure you want to delete this student?"
);

if (!confirmDelete) return;

try {

await api.delete(`/students/${id}`);

loadStudents();

} catch (err) {

alert("Failed to delete student");

}

};

  const resetDevice = async (id) => {
  const ok = window.confirm(
    "Reset this student's device binding?"
  );

  if (!ok) return;

  try {
    await api.put(`/students/${id}/reset-device`);
    alert("Device reset successfully");
    loadStudents();
  } catch (err) {
    alert("Failed to reset device");
  }
};


// ---------- FILTER LOGIC ----------

const filteredStudents = students.filter((student)=>{

return (
student.email?.toLowerCase().includes(search.toLowerCase()) ||
student.mobile?.toString().includes(search)
);

});


// ---------- PAGINATION ----------

const indexOfLast = currentPage * studentsPerPage;
const indexOfFirst = indexOfLast - studentsPerPage;

const currentStudents = filteredStudents.slice(indexOfFirst,indexOfLast);

const totalPages = Math.ceil(filteredStudents.length / studentsPerPage);

const nextPage = ()=>{
if(currentPage < totalPages){
setCurrentPage(currentPage+1);
}
};

const prevPage = ()=>{
if(currentPage > 1){
setCurrentPage(currentPage-1);
}
};


return (

<div style={{padding:"30px"}}>

<div
style={{
display: "flex",
justifyContent: "space-between",
marginBottom: "25px",
alignItems:"center"
}}
>

<h2 style={{margin:0}}>Students</h2>

<button
style={primaryBtn}
onClick={() => setPage({ page: "add-student" })}
>
+ Add New
</button>

</div>


{/* SEARCH CARD */}

<div style={card}>

<h3 style={{marginBottom:"15px"}}>Search Students</h3>

<input
placeholder="Search by Email or Mobile"
value={search}
onChange={(e)=>setSearch(e.target.value)}
style={inputFull}
/>

</div>


{/* TABLE CARD */}

<div style={card}>

<div
style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:"18px"
}}
>
<h3 style={{margin:0}}>Students List</h3>
<div style={{color:"#666",fontSize:"14px"}}>
Total: {filteredStudents.length}
</div>
</div>

<table style={table}>

<thead style={tableHeader}>
<tr>
<th style={th}>#</th>
<th style={th}>Name</th>
<th style={th}>Email</th>
<th style={th}>Mobile</th>
<th style={th}>Account</th>
<th style={th}>Courses</th>
<th style={th}>Actions</th>
</tr>
</thead>

<tbody>

{currentStudents.map((student, index) => (

<tr key={student.id} style={row}>

<td style={td}>{indexOfFirst + index + 1}</td>

<td style={td}>
{[student.first_name, student.last_name]
.filter(Boolean)
.join(" ")}
</td>

<td style={td}>{student.email}</td>

<td style={td}>{student.mobile}</td>


{/* ACCOUNT STATUS */}

<td style={td}>
  <span
    style={{
      background: student.status === "active" ? "#2ecc71" : "#e74c3c",
      color: "white",
      padding: "4px 10px",
      borderRadius: "4px",
      fontSize: "12px",
      textTransform:"capitalize"
    }}
  >
    {student.status}
  </span>
</td>


{/* COURSES STATUS */}

<td style={td}>

<span
style={{
background:"#27ae60",
color:"white",
padding:"4px 8px",
borderRadius:"4px",
marginRight:"6px",
fontSize:"12px",
display:"inline-block",
minWidth:"28px",
textAlign:"center"
}}
>
{student.active_courses || 0}
</span>

<span
style={{
background:"#e74c3c",
color:"white",
padding:"4px 8px",
borderRadius:"4px",
fontSize:"12px",
display:"inline-block",
minWidth:"28px",
textAlign:"center"
}}
>
{student.inactive_courses || 0}
</span>

</td>


{/* ACTIONS */}

<td style={td}>

  <button
  style={resetBtn}
  onClick={() => resetDevice(student.id)}
>
Reset Device
</button>

<button
style={editBtn}
onClick={() =>
setPage({
page: "edit-student",
studentId: student.id
})
}
>
Edit
</button>

<button
style={deleteBtn}
onClick={() => deleteStudent(student.id)}
>
Delete
</button>

</td>

</tr>

))}

{!currentStudents.length && (
<tr>
<td colSpan="7" style={{...td,textAlign:"center",padding:"20px"}}>
No students found
</td>
</tr>
)}

</tbody>

</table>


{/* PAGINATION */}

<div style={{
marginTop:"20px",
display:"flex",
justifyContent:"center",
alignItems:"center",
gap:"10px"
}}>

<button
onClick={prevPage}
style={paginationBtn}
disabled={currentPage === 1}
>
Prev
</button>

<span style={{padding:"5px 10px",fontWeight:"bold"}}>
Page {currentPage} / {totalPages || 1}
</span>

<button
onClick={nextPage}
style={paginationBtn}
disabled={currentPage === totalPages || totalPages === 0}
>
Next
</button>

</div>

</div>

</div>

);

}


/* ---------- UI STYLES ---------- */

const resetBtn = {
  marginRight:"10px",
  background:"#3498db",
  color:"white",
  border:"none",
  padding:"6px 12px",
  borderRadius:"4px",
  cursor:"pointer"
};

const card = {
background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"30px"
};

const inputFull = {
width:"100%",
padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px",
fontSize:"14px"
};

const primaryBtn = {
background:"#2c3e50",
color:"white",
border:"none",
padding:"10px 16px",
borderRadius:"6px",
cursor:"pointer"
};

const editBtn = {
marginRight:"10px",
background:"#f39c12",
color:"white",
border:"none",
padding:"6px 12px",
borderRadius:"4px",
cursor:"pointer"
};

const deleteBtn = {
background:"#e74c3c",
color:"white",
border:"none",
padding:"6px 12px",
borderRadius:"4px",
cursor:"pointer"
};

const paginationBtn = {
padding:"6px 14px",
background:"#2c3e50",
color:"#fff",
border:"none",
borderRadius:"4px",
cursor:"pointer"
};

const table = {
width:"100%",
borderCollapse:"collapse"
};

const tableHeader = {
background:"#f5f6fa",
textAlign:"left"
};

const th = {
padding:"12px 10px",
borderBottom:"1px solid #eee"
};

const td = {
padding:"12px 10px",
borderBottom:"1px solid #eee",
verticalAlign:"middle"
};

const row = {
borderBottom:"1px solid #eee"
};

export default Students;
